import { render, staticRenderFns } from "./ModalAccount.vue?vue&type=template&id=385b7fc7&scoped=true&"
import script from "./ModalAccount.vue?vue&type=script&lang=js&"
export * from "./ModalAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385b7fc7",
  null
  
)

export default component.exports